module.exports = "<ng4-loading-spinner> </ng4-loading-spinner>\n<router-outlet></router-outlet>"